import React from 'react';
import GallectionCoverDumbo from '../../../GallectionCoverDumbo';
import SelectionListItem from '../../../SelectionList/SelectionListItem';
var CollectionListItem = function (_a) {
    var collection = _a.collection, isSelected = _a.isSelected, onChange = _a.onChange;
    return (React.createElement(SelectionListItem, { isSelected: isSelected, control: "checkbox", label: collection.name, prefix: React.createElement(GallectionCoverDumbo, { width: 70, height: 40, gallection: collection }), fillContainerWidth: true, onChange: function () { return onChange({ folderId: collection.folderId }); } }));
};
CollectionListItem.displayName = 'CollectionListItem';
export default CollectionListItem;
//# sourceMappingURL=CollectionListItem.js.map